// @flow

// ignoring test coverage for this file until we can find a way to test logInteraction
/* istanbul ignore file */

/**
 * For use by sponsored hero.
 * Displays a pin, location name, and links to that geo's page.
 *
 * @author rbernard
 * @since Jan 2019
 */

import * as React from 'react';

import classNames from '@ta/common.classnames';
import { Link } from '@ta/common.routing';
import { featureIsEnabled } from '@ta/common.features';
import { InteractionLogger } from '@ta/tracking.interactions';

import type { LocationInformation } from './types';

import styles from './GeoPin.less';

type Props = {
  location: LocationInformation,
};

const GeoPin = ({ location }: Props) => {
  if (!location) {
    return null;
  }
  const label =
    (location.additionalNamesMap && location.additionalNamesMap.LONG) || // Java uses additionalNamesMap.LONG
    (location.additionalNames && location.additionalNames.long); // GraphQL uses "additionalNames.long"
  const urlBase = featureIsEnabled('navigation_to_scoped_home') ? '/Home' : '/Tourism';
  const url = location.locationId && `${urlBase}-g${location.locationId}`;
  if (label && url) {
    return (
      <InteractionLogger>
        {logInteraction => (
          <Link
            className={styles.geoPin}
            href={url}
            onClick={e => logInteraction(e, 'heroGeoPinClick')}
          >
            <span className={classNames(styles.label, 'ui_icon', 'map-pin-fill')}>{label}</span>
          </Link>
        )}
      </InteractionLogger>
    );
  }
  return null;
};

export default GeoPin;
